// extracted by mini-css-extract-plugin
export default {"heroForm":"HeroForm_heroForm__6nQtP","close":"HeroForm_close__W6ixt","label":"HeroForm_label__bQquR"};